var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSection2Icon2 = function SvgSection2Icon2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 10,
    fill: "#F9F6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12h4V8H8v4Zm6 12h4v-4h-4v4Zm-6 0h4v-4H8v4Zm0-6h4v-4H8v4Zm6 0h4v-4h-4v4Zm6-10v4h4V8h-4Zm-6 4h4V8h-4v4Zm6 6h4v-4h-4v4Zm0 6h4v-4h-4v4Z",
    fill: "#6400FF"
  })));
};
export default SvgSection2Icon2;